<template>
  <div class="attributions">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <h1>Attributions</h1>

        <p>This site is written in <a href="https://vuejs.org/" target="_blank">Vue.js</a> and along the way I have used some amazing libraries.</p>

        <p><a href="https://spacy.io/api/doc" target="_blank">SpaCy API</a> to do entity analysis.</p>
        <p><a href="http://iamdanfox.github.io/typetype/jquery.typetype.min.js" target="_blank">TypeType</a> to simulate typing into a textarea.</p>
        <p><a href="https://www.npmjs.com/package/vue-text-highlight" target="_blank">Highlight-within-text-area</a> to highlight recognised entities in lovely pastel colours (colour choice my own).</p>
        <p><a href="https://ml5js.org/" target="_blank">ml5.js</a> to generate <router-link to="/dnd">DND character bios</router-link>.</p>

        <p>I am extremely grateful to all the authors of these libraries.</p>
      </div>
      <div class="sml-col"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Attributions'
  }
</script>
<style scoped>
  .attributions {
    text-align: center;

  }
  
  .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  @media screen and (max-width: 500px) {
    .flex-grid {
      display: block;
    }
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 32%;
  }

  .flex-grid-thirds .sml-col {
    width: 20%;
    text-align: left;
}
</style>
